import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription, observable } from 'rxjs';
import { map, catchError, switchMap, finalize } from 'rxjs/operators';
import { UserModel } from '../_models/user.model';
import { AuthModel } from '../_models/auth.model';
// import { AuthHTTPService } from './auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthHTTPService } from './auth-http/auth-http.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  // private fields
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`; 

  // public fields
  currentUser$: Observable<UserModel>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<UserModel>;
  isLoadingSubject: BehaviorSubject<boolean>;
  public _user$ = new BehaviorSubject<any[]>([]);

  get states$() {
    return this._user$.asObservable();
  }

  get currentUserValue(): UserModel {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: UserModel) {
    this.currentUserSubject.next(user);
  }

  constructor(
    private authHttpService: AuthHTTPService,//AuthHTTPService,
    private router: Router
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<UserModel>(undefined);
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
    const subscr = this.getUserByToken().subscribe();
    this.unsubscribe.push(subscr);
  }

  // public methods
  login(email: string, password: string): Observable<UserModel> {   
    this.isLoadingSubject.next(true); 
    return this.authHttpService.login(email, password).pipe(
      map((auth: AuthModel) => {  
       // console.log(auth);         
        const result = this.setAuthFromLocalStorage(auth);      
        return result;
      }),
      switchMap(() => this.getUserByToken()),
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  logout() {
    localStorage.removeItem(this.authLocalStorageToken);    
    this.router.navigate(['/auth/login'], {
      queryParams: {},
    });
    // window.location.reload();
  }

  getUserByToken(): Observable<any> {
    const auth = this.getAuthFromLocalStorage(); 
    // console.log("auth is",auth)
    if (!auth || !auth.accessToken) {
      return of(undefined); 
    }

    this.isLoadingSubject.next(true);    
    return this.authHttpService.getUserByToken(auth.accessToken).pipe(  
      map((user: any) => {
        if (user) {
          this.currentUserSubject = new BehaviorSubject<any>(user);
        } else {
          this.logout();
        }
        return user;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );  
  }

  // need create new user then login
  registration(user: UserModel): Observable<any> {
    var res;
    this.isLoadingSubject.next(true);    
    return this.authHttpService.createUser(user).pipe( 
      // map(() => { 
      //   // console.log("called user 2",respone); 
      //   // if(respone.Succeeded == "true")
      //   // {
      //   //   res =  respone; 
      //   // }
      //   this.isLoadingSubject.next(false);
      // }),
      // //switchMap(() => this.login(user.Email, user.Password)),
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );    
  }

  forgotPassword(email: string): Observable<boolean> {
    this.isLoadingSubject.next(true);
    return this.authHttpService
      .forgotPassword(email)
      .pipe(finalize(() => this.isLoadingSubject.next(false)));
  }

  // private methods
  private setAuthFromLocalStorage(auth: AuthModel): boolean {
    // store auth accessToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (auth && auth.accessToken) {
      localStorage.setItem(this.authLocalStorageToken, JSON.stringify(auth));
      // console.log("called set authLocalStorageToken");
      return true;
    }
    return false;
  }

  public getAuthFromLocalStorage(): AuthModel {
    try {
      const authData = JSON.parse(
        localStorage.getItem(this.authLocalStorageToken)
      );
      // console.log("called get authLocalStorageToken", authData);
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
